// frontend/src/InventoryKnowledge/apiClient.js — thin wrapper around authenticatedFetch for /api/inventory-knowledge (same shape as GiftCards/apiClient.js).
import { authenticatedFetch } from '../AuthComponent';

const BASE = '/api/inventory-knowledge';

async function jsonOrThrow(resp) {
  if (!resp.ok) {
    let detail = '';
    try { const j = await resp.json(); detail = typeof j.detail === 'string' ? j.detail : ''; } catch { /* the status is enough */ }
    throw new Error(detail || `${resp.status} ${resp.statusText}`);
  }
  return resp.json();
}
const send = (method, path, body) => authenticatedFetch(`${BASE}${path}`, { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(jsonOrThrow);
const get = (path) => authenticatedFetch(`${BASE}${path}`).then(jsonOrThrow);

export const imkApi = {
  options: () => get('/options'),
  entries: () => get('/entries'),
  entry: (id) => get(`/entries/${id}`),
  create: (body) => send('POST', '/entries', body),
  update: (id, body) => send('PUT', `/entries/${id}`, body),
  setStatus: (id, status) => send('POST', `/entries/${id}/status`, { status }),
  feedback: (state) => get(`/feedback${state ? `?state=${state}` : ''}`),
  handle: (id, action, entryId) => send('POST', `/feedback/${id}`, { action, entry_id: entryId }),
  history: () => get('/history'),
};
